export interface Alert {
    id: number;
    active: boolean;
    name: string;
    targetcustomerlicenseplate: string | null;
    targetgroupname: string | null;
    targetstaffname: string | null;
    executeonlyifstaffavailable?: boolean;
    runonlyoncepercustomerorstaff?: boolean;
    smstoadmins?: string | null;
    smstoowners?: string | null;
    smstoavailablestaff?: string | null;
    createdat: string;
    createdatString: string;
    targetnewcustomers: boolean;
    automaticallymarkasexecuted?: boolean;
};

// we can't use Omit<Alert, 'id'> because data expected from server is camelcase but the data returned from server is all lowercase
export interface CreateAlertPayload {
    name: string;
    executeOnlyIfStaffAvailable: boolean;
    runOnlyOncePerCustomerOrStaff: boolean;
    smsToAdmins?: string;
    smsToOwners?: string;
    smsToAvailableStaff?: string;
    targetCustomerLicensePlate?: string;
    automaticallyMarkAsExecuted?: boolean;
}

export const ValidateAlertReasons = {
    ALERT_ALREADY_EXECUTED_TODAY: 'alreadyExecutedToday',
    INVALID_CONFIRMATION_ID: 'invalidConfirmationId',
};

export type ValidateAlertReason = typeof ValidateAlertReasons.ALERT_ALREADY_EXECUTED_TODAY | typeof ValidateAlertReasons.INVALID_CONFIRMATION_ID;

export interface ValidateAlertExistsResponse {
    data: {
        status: string;
        reason?: ValidateAlertReason;
        licensePlate?: string;
    }
    result: string;
}

export interface ConfirmAlertResponse {
    data: {
        status: string;
        reason?: string;
    }
    result: string;
}
